import React, { useMemo, useState } from 'react';
import { Grid } from '@material-ui/core';
import { css } from '@emotion/react';
import { colors } from '@/styles';
import { PrimaryButton } from '@/styles/blocks';
import CarrierMappingRow from './CarrierMappingRow';

const SubregionDetailsPopover = ({ isOnwardAdmin, subregion, collapsed, carriersForLeg, loading, callbacks }) => {
    const [newMapping, setNewMapping] = useState(null);

    const mappings = useMemo(
        () => [...(subregion?.carriers || []), ...(newMapping ? [newMapping] : [])],
        [subregion, newMapping]
    );

    return (
        <Grid
            container
            direction="column"
            css={css`
                position: absolute;
                width: 500px;
                top: 0;
                left: 0;
                border: 1px solid #00000052;
                background: ${colors.white.primary};
                max-height: 100%;
                flex-wrap: nowrap;
                overflow-y: auto;
            `}
        >
            {mappings.map((mapping) => (
                <CarrierMappingRow
                    key={mapping.mapping_id || 'new'}
                    mapping={mapping}
                    carriersForLeg={carriersForLeg}
                    collapsed={collapsed}
                    loading={loading}
                    callbacks={callbacks}
                    isOnwardAdmin={isOnwardAdmin}
                    onClearNew={() => setNewMapping(null)}
                />
            ))}
            {!newMapping ? (
                <Grid
                    container
                    css={css`
                        padding: 12px 12px 24px;
                    `}
                >
                    <PrimaryButton
                        fullWidth
                        css={css`
                            height: 40px;
                        `}
                        onClick={() =>
                            setNewMapping({
                                subregion_id: subregion.subregion_id,
                                is_primary: !subregion?.carriers?.length ? true : null,
                            })
                        }
                    >
                        Add Carrier
                    </PrimaryButton>
                </Grid>
            ) : null}
        </Grid>
    );
};

export default SubregionDetailsPopover;
